import { PsychologistRequestDetail } from '../../shared/models/request-psychologist-detail.model';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class RequestPsychologistService {
  private baseURL = environment.baseURL;
  constructor(private http: HttpClient) {}

  createPsychologistDetail(detail: PsychologistRequestDetail) {
    return this.http.post<PsychologistRequestDetail>(
      `${this.baseURL}/psychologists-request`,
      detail
    );
  }

  getPsychologistDetail(requestID: number) {
    return this.http.get<PsychologistRequestDetail>(
      `${this.baseURL}/psychologists-request/${requestID}`
    );
  }

  updatePsychologistDetail(
    requestID: number,
    detail: PsychologistRequestDetail
  ) {
    return this.http.put<PsychologistRequestDetail>(
      `${this.baseURL}/psychologists-request/${requestID}`,
      detail
    );
  }

  deletePsychologistDetail(requestID: number) {
    return this.http.delete<PsychologistRequestDetail>(
      `${this.baseURL}/psychologists-request/${requestID}`
    );
  }

  sendSlackNotification(psychologistRequestId: number) {
    return this.http.post(
      `${this.baseURL}/psychologists-request/send-slack-notification`,
      null,
      {
        params: { psychologistRequestId },
      }
    );
  }
}
